import React from 'react';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';

interface PositionsDetailsErrorProps {
  onRetry(): void;
}

export const PositionsDetailsError: React.FC<PositionsDetailsErrorProps> = ({ onRetry }) => {
  return (
    <tbody>
      <tr style={{ borderBottom: 'none' }}>
        <td colSpan={8}>
          <Box p={120} bg="bg">
            <ErrorState onAction={onRetry} />
          </Box>
        </td>
      </tr>
    </tbody>
  );
};
